import React, { useState } from 'react'
import styled from 'styled-components'
import colors from 'theme/colors';

export default function DynamicProfileBackground({
    img,
    size,
    variant = 'rounded',
    bgColor = colors.neutralDark,
    event = false
}) {
    const [hasError, setHasError] = useState(false);
    const placeholder = event ? '/assets/images/placeholder-events.png' : '/assets/images/placeholder-background.png';
    const showImage = img && !hasError;

    return (
        <Picture size={size} bgColor={bgColor} variant={variant}>
            <ImageBackground
                src={showImage ? img : placeholder}
                alt='imagem de perfil'
                size={size}
                variant={variant}
                onError={() => setHasError(true)}
            />
        </Picture>
    )
}

const Picture = styled.div`
    width: 100%;
    
    ${({ bgColor }) => bgColor && `
        background: ${bgColor};
    `}

    ${({ size }) => size && `
        height: ${size};
    `}

    ${({ variant }) => variant === 'rounded' && `
        border-radius: 4px 4px 0 0;
    `}

    ${({ variant }) => variant === 'squired' && `
        border-radius: 0;
    `}
    
`;

const ImageBackground = styled.img`
    width: 100%;
    object-fit: cover;
    ${({ size }) => size && `
        height: ${size};
    `}

    ${({ variant }) => variant === 'rounded' && `
        border-radius: 4px 4px 0 0;
    `}

    ${({ variant }) => variant === 'squired' && `
        border-radius: 0;
    `}
`;

